const config = require('./config-' + process.env.NODE_ENV)

module.exports = config;


//////////////////
// WEBPACK FOOTER
// ./config/project/index.js
// module id = U5zo
// module chunks = 60